import React, {useEffect} from 'react';
import HeaderSubPage from "./partial/HeaderSubPage";

const AccessibilityDeclaration = () => {
    useEffect(() => {
        document.title = `Barrierefreiheitserklärung`;
    }, []);
    return (
        <div>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Barrierefreiheitserklärung'}
                               subtitle={'Barrierefreiheitserklärung'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1 className="post_list_title">
                                    <span><strong>Barrierefreiheitserklärung</strong></span>
                                </h1>
                                <div>
                                    <h1>Erkl&auml;rung zur Barrierefreiheit</h1>
                                    <p>Wir (GLOBALIS Erlebnisreisen GmbH) als Websitebetreiber sind bem&uuml;ht, die
                                        Website in Einklang mit den einschl&auml;gigen Vorschriften zur Barrierefreiheit
                                        zu gestalten. F&uuml;r uns gelten folgende Rechtsvorschriften:
                                    </p>
                                    <p>Hessisches
                                        Gesetz zur Gleichstellung von Menschen mit Behinderungen (Hessisches
                                        Behinderten-Gleichstellungsgesetz - HessBGG) und Hessische Verordnung &uuml;ber
                                        barrierefreie Informationstechnik (BITV HE 2019)
                                    </p>
                                    <h2>Website</h2>
                                    <p>Diese Erkl&auml;rung zur Barrierefreiheit gilt f&uuml;r die
                                        Website <a href="https://www.globalis.de/">https://www.globalis.de/</a> und alle ihre Subdomains.
                                    </p>
                                    <h2>Feedback und Kontaktangaben</h2>
                                    <p>Sind Ihnen M&auml;ngel beim barrierefreien
                                        Zugang zu Inhalten auf unserer Website aufgefallen oder haben Sie Anmerkungen
                                        sowie
                                        Fragen zum barrierefreien Zugang? Melden Sie sich gerne bei uns unter:
                                    </p>
                                    <p>GLOBALIS Erlebnisreisen GmbH<br/>
                                        Uferstra&szlig;e 24<br/>
                                        61137 Sch&ouml;neck - DE<br/>
                                        <br/>
                                        Telefon: 0 61 87 / 48 04 - 840<br/>
                                        Telefax: 0 61 87 / 48 04 - 335<br/>
                                        e-Mail: info(at)globalis.de<br/>
                                        www.globalis.de<br/>
                                    </p>
                                    <p><a href="https://www.globalis.de/kontakt/">https://www.globalis.de/kontakt/</a>
                                    </p>
                                    <h2>Telefonische Hilfe f&uuml;r Menschen mit Behinderungen</h2>
                                    <p>Wir
                                        verf&uuml;gen &uuml;ber eine telefonische Hilfe-Hotline f&uuml;r Menschen mit
                                        Behinderungen und die Nutzer unterst&uuml;tzender Technologien. Diese
                                        k&ouml;nnen
                                        Sie unter folgender Telefonnummer erreichen: <strong>0 61 87 / 48 04 -
                                            840</strong>
                                    </p>
                                    <h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
                                    <p>Diese Website ist nicht vollst&auml;ndig mit den f&uuml;r uns geltenden
                                        Vorschriften zur Barrierefreiheit vereinbar. Im Einzelnen:
                                    </p>
                                    <h3>Unvereinbarkeit mit den Rechtsvorschriften zur Barrierefreiheit</h3>
                                    <p>Die
                                        nachstehend aufgef&uuml;hrten Inhalte sind nicht mit den einschl&auml;gigen
                                        gesetzlichen Vorschriften zur Barrierefreiheit vereinbar:
                                    </p>
                                    <p>Die Website wird
                                        nach bestem Wissen und Gewissen gem&auml;&szlig; den geltenden gesetzlichen
                                        Vorschriften zur Barrierefreiheit &uuml;berpr&uuml;ft und gepflegt. Dennoch kann
                                        es
                                        zu einzelnen Einschr&auml;nkungen kommen, insbesondere bei:<br/>
                                        <br/>
                                        PDF-Dokumenten, die nicht vollst&auml;ndig barrierefrei aufbereitet sind<br/>
                                        <br/>
                                        Interaktiven Elementen, die nicht durchg&auml;ngig per Tastatur bedienbar
                                        sind<br/>
                                        <br/>
                                        Bildern ohne oder mit unzureichenden Alternativtexten<br/>
                                        <br/>
                                        Textbereichen mit nicht ausreichendem Farbkontrast zum Hintergrund<br/>
                                        <br/>
                                        Formularfeldern und Filterfunktionen mit fehlenden oder nicht korrekt
                                        zugeordneten
                                        Labels<br/>
                                        <br/>
                                        Wir arbeiten kontinuierlich daran, bestehende Barrieren zu identifizieren und zu
                                        beseitigen.
                                    </p>
                                    <h3>Unverh&auml;ltnism&auml;&szlig;ige Belastung</h3>
                                    <p>Folgende Inhalte werden
                                        nicht barrierefrei zur Verf&uuml;gung gestellt, weil dies f&uuml;r uns zu einer
                                        unverh&auml;ltnism&auml;&szlig;igen Belastung f&uuml;hren w&uuml;rde:
                                    </p>
                                    <p>Einige
                                        Inhalte auf dieser Website sind derzeit nicht barrierefrei gestaltet. Die
                                        Umsetzung
                                        entsprechender Ma&szlig;nahmen w&uuml;rde mit
                                        unverh&auml;ltnism&auml;&szlig;igem
                                        Aufwand einhergehen, insbesondere im Hinblick auf:<br/>
                                        <br/>
                                        Die nachtr&auml;gliche barrierefreie Aufbereitung umfangreicher &auml;lterer
                                        PDF-Dokumente<br/>
                                        <br/>
                                        Eine vollst&auml;ndige barrierefreie Umsetzung einzelner
                                        Drittanbieter-Komponenten,
                                        auf deren Gestaltung wir keinen direkten Einfluss haben<br/>
                                        <br/>
                                        Wir bewerten regelm&auml;&szlig;ig den Aufwand und die Zumutbarkeit technischer
                                        Anpassungen und streben an, auch diese Inhalte mittelfristig m&ouml;glichst
                                        barrierearm zu gestalten.
                                    </p>
                                    <h3>Ausnahmen vom Anwendungsbereich der Vorschriften zur Barrierefreiheit</h3>
                                    <p>Folgende nicht barrierefreie Inhalte auf dieser Website fallen nicht unter den
                                        Anwendungsbereich der Vorschriften zur Barrierefreiheit:
                                    </p>
                                    <p>
                                        Inhalte von Dritten, die nicht im Einflussbereich des Websitebetreibers liegen
                                        (z.
                                        B. eingebettete Inhalte von externen Anbietern)<br/>
                                        <br/>
                                        PDF-Dokumente, die vor dem 23. September 2018 ver&ouml;ffentlicht wurden und
                                        nicht
                                        aktiv zur Nutzung ben&ouml;tigt werden<br/>
                                        <br/>
                                        Audio- und Video-Inhalte, die vor dem 23. September 2020 ver&ouml;ffentlicht
                                        wurden<br/>
                                        <br/>
                                        Diese Inhalte sind von der gesetzlichen Verpflichtung zur Barrierefreiheit
                                        ausgenommen, werden jedoch bei Gelegenheit durch barrierearme Alternativen
                                        ersetzt,
                                        sofern m&ouml;glich.
                                    </p>
                                    <h3>Barrierefreie Alternativen</h3>
                                    <p>F&uuml;r unsere nicht barrierefreien Inhalte
                                        stellen wir folgende barrierefreie Alternativen zur Verf&uuml;gung:
                                    </p>
                                    <p>
                                        Informationen aus PDF-Dokumenten k&ouml;nnen auf Anfrage in barrierefreier Form
                                        (z.
                                        B. als HTML oder barrierefreie PDF) bereitgestellt werden<br/>
                                        <br/>
                                        F&uuml;r komplexe Grafiken oder Bilder ohne Alternativtexte bieten wir bei
                                        Bedarf
                                        textliche Erl&auml;uterungen an<br/>
                                        <br/>
                                        Bei Problemen mit der Bedienbarkeit einzelner Funktionen unterst&uuml;tzen wir
                                        Nutzer*innen gern pers&ouml;nlich per E-Mail oder Telefon<br/>
                                        <br/>
                                        Bitte kontaktieren Sie uns, wenn Sie bestimmte Inhalte in barrierefreier Form
                                        ben&ouml;tigen. Wir bem&uuml;hen uns um eine zeitnahe Bereitstellung.
                                    </p>
                                    <h3>Evaluationsmethode</h3>
                                    Die Barrierefreiheit dieser Website wurde durch eine
                                    Selbstbewertung auf Grundlage der Anforderungen der
                                    Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) sowie der Web Content
                                    Accessibility Guidelines (WCAG) 2.1 &uuml;berpr&uuml;ft. Dabei kamen manuelle
                                    Pr&uuml;fungen sowie unterst&uuml;tzende Werkzeuge wie automatisierte Tests und
                                    Screenreader-Simulationen zum Einsatz.
                                    <h2>Durchsetzungsverfahren</h2>
                                    <p>Sollten Sie der Ansicht sein, dass Sie durch eine
                                        nicht ausreichende barrierefreie Gestaltung unserer Website benachteiligt sind,
                                        k&ouml;nnen Sie sich an die zust&auml;ndige Durchsetzungsstelle wenden. Diese
                                        erreichen Sie unter:
                                    </p>
                                    <p>Landesbeauftragte f&uuml;r barrierefreie IT<br/>Neue
                                        B&auml;ue 2<br/>35390 Gie&szlig;en
                                    </p>
                                    <p>Telefon: 0641 303-2901<br/>E-Mail: <a
                                        href="mailto:ueberwachung-lbit@rpgi.hessen.de">ueberwachung-lbit@rpgi.hessen.de</a>
                                    </p>
                                    <h2>Erstellung dieser Erkl&auml;rung zur Barrierefreiheit</h2>
                                    <p>Diese Erkl&auml;rung wurde am 02.05.2025 erstellt.</p>
                                    <p>Die Erkl&auml;rung wurde zuletzt am 02.05.2025 &uuml;berpr&uuml;ft.</p>
                                    <p>Quelle: <a
                                        href="https://www.e-recht24.de/barrierefreiheitserklaerung.html">eRecht24</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default AccessibilityDeclaration;